module.exports = __webpack_public_path__ + "static/media/FiberousVeryThinRoot3.748ee269.png";